/* ExerciseWindowConfigurationService / MaturityScheduleConfigurationService not available in production api-services build
import type { ExternalTableSchema } from '@packages/table-builder';

export const exercisabilityInstructionsTable: ExternalTableSchema = {
  metadata: {
    title: 'Exercise Window Configuration',
    entity: 'ExerciseWindowConfiguration',
  },

  dataSource: {
    endpoint: '/api/award-settlement/api/app/exercise-window-configuration',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Sorting: 'table.sorting',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
    },
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      type: 'text',
      width: 250,
      sortable: true,
    },
    {
      field: 'isEnabled',
      header: 'Enabled',
      type: 'badge',
      width: 100,
      align: 'center',
      sortable: true,
      conditionalValues: { true: 'Yes', false: 'No' },
      badge: { statusMap: { true: 'success', false: 'error' }, defaultVariant: 'error' },
    },
    {
      field: 'boundaryCount',
      header: 'Boundaries',
      type: 'number',
      width: 100,
      align: 'center',
      sortable: false,
    },
  ],

  actions: {
    toolbar: {
      primary: { id: 'ADD_EXERCISABILITY_INSTRUCTIONS', label: 'Create' },
    },
    row: [
      { id: 'VIEW_EXERCISABILITY_INSTRUCTIONS', label: 'View' },
      { id: 'EDIT_EXERCISABILITY_INSTRUCTIONS', label: 'Edit' },
      { id: 'DELETE_EXERCISABILITY_INSTRUCTIONS', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: true, placeholder: 'Search by name' },
    pagination: { mode: 'pagination', defaultSize: 10 },
    defaultSort: { field: 'name', direction: 'asc' },
  },
};
*/
